function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6953 8.07812L6.57031 5.57031C6.19531 5.38281 5.75 5.64062 5.75 6.0625V10.9375C5.75 11.3828 6.19531 11.6406 6.57031 11.4297L10.6953 9.0625C11.0938 8.85156 11.0938 8.3125 10.6953 8.07812ZM13.8125 8.5C13.8125 5.28906 11.2109 2.6875 8 2.6875C4.78906 2.6875 2.1875 5.28906 2.1875 8.5C2.1875 11.7109 4.78906 14.3125 8 14.3125C11.2109 14.3125 13.8125 11.7109 13.8125 8.5ZM3.3125 8.5C3.3125 5.92188 5.39844 3.8125 8 3.8125C10.5781 3.8125 12.6875 5.92188 12.6875 8.5C12.6875 11.1016 10.5781 13.1875 8 13.1875C5.39844 13.1875 3.3125 11.1016 3.3125 8.5Z",
  fill: "#2B82F7"
});

var SvgIcnPlay16Px = function SvgIcnPlay16Px(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnPlay16Px, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn-play-16px.957e94c4.svg";
export { ForwardRef as ReactComponent };